import type { CalculatorMeta } from '../../types/calculator';

const meta: CalculatorMeta = {
  route: '/break-even-growth-calculator',
  component: () => import('../../routes/BreakEvenGrowthCalculator.svelte'),
  card: {
    id: 'break-even-growth-calculator',
    title: 'Break-Even Growth Calculator',
    description: 'Find out when a higher-rate investment catches up to a larger principal investment through compound growth.',
    icon: 'compare_arrows',
    iconBgClass: 'bg-violet-50',
    iconTextClass: 'text-violet-600',
    href: '/break-even-growth-calculator',
    category: 'Savings & Investing',
  },
  seo: {
    title: 'Break-Even Growth Calculator – Compare Investment Growth Rates',
    description: 'Free break-even growth calculator. Find when a higher-rate investment catches up to a larger portfolio through compound growth. Supports multiple compounding frequencies.',
  },
};

export default meta;